<template>
  <div>
    <h2><router-link :to="{ name: 'admin-design-survey' }">Design</router-link> - Edit {{ activePage.title }}</h2>
    <tabs cache-lifetime="0" @changed="handleTabChange($event)">
      <tab name="Basic Info">
        <vue-form-generator
          :schema="buildSchema('page', 'pageSchema', 'basicInfo', 'edit')"
          :model="formModel"
          :options="formOptions"
          class="vue-form-generator--admin">
        </vue-form-generator>
      </tab>
      <tab name="Page Conditions">
        <vue-form-generator
          :schema="buildSchema('page', 'pageSchema', 'pageConditions', 'edit')"
          :model="objects[activeObject]"
          :options="formOptions"
          class="vue-form-generator--admin">
        </vue-form-generator>

        <div class="list-view list-view--inline" v-if="objects.length > 1">
          <div class="list-view__header">
            <div>Field</div>
            <div>Condition</div>
            <div>Priority</div>
            <div>Next Page</div>
            <div>Actions</div>
          </div>

          <div class="list-view__row" v-for="(pageCondition, index) in objects" v-if="index > 0">
            <div>{{ fieldById(pageCondition.field_id).title }}</div>
            <div>{{ friendlyOperatorName(pageCondition.operator) }} ({{ pageCondition.operator }}): {{ pageCondition.value }}</div>
            <div>{{ pageCondition.priority }}</div>
            <div>{{ pageById(pageCondition.next_page_id).title }}</div>
            <div>
              <button class="icon-button" @click="editObject(index)"><i class="material-icons">mode_edit</i></button>
              <button class="icon-button" @click="deleteObject(pageCondition)"><i class="material-icons">delete</i></button>
            </div>
          </div>
        </div>
      </tab>
    </tabs>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import editForm from '@/mixins/edit-form';
  import inlineEditForm from '@/mixins/inline-edit-form';

  export default {
    name: 'admin-edit-page',
    mixins: [editForm, inlineEditForm],

    data: () => {
      return {
        formIndex: 'admin-design-survey',
        formName: 'Page',
        inlineName: 'PageCondition',
        inlineId: 'conditions',
      };
    },

    computed: {
      ...mapGetters('admin', [
        'activePage',
        'activeField',
        'pageById',
        'fieldById',
        'friendlyOperatorName',
      ]),
    },

    watch: {
      activePage(oldPage, newPage) {
        this.defineFormObjects();
        if (this.activePage.id !== undefined && oldPage.id !== newPage.id) {
          this.fetchPageConditions();
        }
        this.setupObjects();
      },

      activeField: {
        handler() {
          this.addFieldsToDropdown();
        },
        deep: true,
      },
    },

    methods: {
      ...mapActions('admin', [
        'addFieldsToDropdown',
        'fetchFields',
        'fetchPageConditions',
      ]),
    },

    created() {
      if (this.activePage.id) {
        this.fetchPageConditions();
      }
    },
  };
</script>
